var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5254 17.5L23.788 12.2373C24.0707 11.9547 24.0707 11.4964 23.788 11.212C23.5054 10.9293 23.0471 10.9293 22.7627 11.212L17.5 16.4746L12.2373 11.2138C11.9547 10.9312 11.4964 10.9312 11.212 11.2138C10.9293 11.4964 10.9293 11.9547 11.212 12.2391L16.4746 17.5L11.2138 22.7627C10.9312 23.0453 10.9312 23.5036 11.2138 23.788C11.3551 23.9293 11.5399 24 11.7264 24C11.9112 24 12.0978 23.9293 12.2391 23.788L17.5 18.5254L22.7627 23.788C22.904 23.9293 23.0888 24 23.2754 24C23.4601 24 23.6467 23.9293 23.788 23.788C24.0707 23.5054 24.0707 23.0471 23.788 22.7627L18.5254 17.5Z",
    fill: "#F29339",
    stroke: "#F29339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCloseIcon);
export default __webpack_public_path__ + "static/media/orange-close-icon.9594d6cc3bc09710e7716b4aa9c74d6e.svg";
export { ForwardRef as ReactComponent };